/**
 * Created by Carsten Bühler
 * User: CBuehler on 15.02.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import * as DateFormat from '../../utils/date-format.js';
import DateTimeDisplay from '../DateTimeDisplay';

const TimeLineItem = ({ timestamp, userMeta, children }) =>
    <div className="journal-timeline-item">
        <div className="date">
            <DateTimeDisplay timestamp={timestamp} dateFormat={DateFormat.formatDate}/>
            <small className="text-navy">
                <DateTimeDisplay timestamp={timestamp} dateFormat={DateFormat.formatTimeNoSeconds}/>
            </small>
            {
                userMeta &&
                <small>
                    {userMeta.userName + (userMeta.teamName ? ' (' + userMeta.teamName + ')' : '')}
                </small>
            }
        </div>

        <div className="content">
            {children}
        </div>
    </div>;

TimeLineItem.propTypes = {
    timestamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    userMeta: PropTypes.object,
    iconClassName: PropTypes.string,
    children: PropTypes.node
};

export default TimeLineItem;



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/TimeLineItem.jsx